"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleSaveOfferButton = ToggleSaveOfferButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const auth_context_1 = require("@src/context/auth-context");
const antd_1 = require("antd");
const account_1 = require("@src/types/account");
const elements_1 = require("@src/components/elements");
const react_intl_1 = require("react-intl");
const useConfig_1 = require("@src/hooks/useConfig");
const icons_1 = require("@ant-design/icons");
const styled_components_1 = require("styled-components");
const account_context_1 = require("@src/context/account-context");
const saved_offer_context_1 = require("@src/context/saved-offer-context");
const ToggleSaveOfferButton_style_1 = require("./ToggleSaveOfferButton.style");
function ToggleSaveOfferButton({ offerId }) {
    const { savedOffers, removeSavedOffer, createSavedOffer } = (0, saved_offer_context_1.useSavedOffersContextValue)();
    const isOfferSaved = savedOffers.map(({ offerId: id }) => id).includes(offerId);
    const theme = (0, styled_components_1.useTheme)();
    const { checkAuthentication } = (0, auth_context_1.useAuthContextValue)();
    const intl = (0, react_intl_1.useIntl)();
    const config = (0, useConfig_1.useConfig)();
    const account = (0, account_context_1.useAccount)();
    const isInAdmin = (account === null || account === void 0 ? void 0 : account.accountTypeId) === config.accountType.company;
    const toggleSaveOffer = async () => {
        try {
            const authenticatedAccount = await checkAuthentication();
            if (authenticatedAccount && authenticatedAccount.account_type_id === 1) {
                antd_1.notification.warning({
                    message: intl.formatMessage({
                        id: 'general.warning',
                    }),
                    description: intl.formatMessage({
                        id: 'general.action_not_allowed_for_company_account',
                    }),
                });
                return;
            }
            if (isOfferSaved) {
                removeSavedOffer(offerId);
            }
            else {
                createSavedOffer(offerId);
            }
        }
        catch (err) {
            if (err !== account_1.AccountErrorCode.login_canceled) {
                antd_1.notification.error({
                    message: intl.formatMessage({
                        id: 'general.error',
                    }),
                    description: intl.formatMessage({
                        id: 'general.something_went_wrong',
                    }),
                });
                console.error(err);
            }
        }
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !isInAdmin && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(elements_1.Button, { size: "middle", onClick: e => {
                    e.preventDefault();
                    toggleSaveOffer();
                }, type: "secondary", children: isOfferSaved ? ((0, jsx_runtime_1.jsx)(icons_1.HeartFilled, { style: { color: theme.color.error } })) : ((0, jsx_runtime_1.jsxs)("div", { className: "flex-center", children: [(0, jsx_runtime_1.jsx)(icons_1.HeartOutlined, {}), (0, jsx_runtime_1.jsx)(ToggleSaveOfferButton_style_1.SaveButtonText, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.save" }) })] })) }) })) }));
}
